export class NextParams
{
    constructor (public oldStepIdx: number, public newStepIdx: number)
    {
    }
}
